import store from '@/store/index';
import { parseQueryParams } from '@/utils/url';
import { isWeChatBrowser } from '@/utils/wxTools';
import { RouterQuery } from '@/typeAll';

export function initStoreValue() {
    const pageHref = location.href;
    const qObj = parseQueryParams(pageHref);
    const token = qObj[RouterQuery.auth];
    const inWx = isWeChatBrowser();
    store.commit('setAny', {
        token,
        inWx,
    });
}
